// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.correctAnswerCard {
  background-color: #eafff0;
  border-color: #a2ffbb;
  margin-bottom: 16px;
}
.wrongAnswerCard {
  background-color: #ffeaea;
  border-color: #ffa2a2;
  margin-bottom: 16px;
}

/* ── Radio: incorrect (red) ── */
.radio-red .ant-radio-inner {
  border-color: red;
}
.radio-red .ant-radio-inner::after {
  background-color: red;
}

/* ── Radio: correct (green) ── */
.radio-green .ant-radio-inner {
  border-color: green !important;
  background: green;
}
.radio-green .ant-radio-inner::after {
  background-color: green !important;
}
.radio-green .ant-radio-checked .ant-radio-inner {
  border-color: green;
  background-color: green;
}

/* ── Radio: user's wrong pick ── */
.radio-incorrect .ant-radio-checked .ant-radio-inner {
  border-color: red;
  background-color: red;
}

/* ── Hover states ── */
.reviewModuleMainDiv .radio-green:hover .ant-radio-inner {
  border-color: green;
}
.reviewModuleMainDiv .radio-incorrect:hover .ant-radio-inner {
  border-color: red !important;
}

.radio-correct {
  color: green;
}

/* ── Disable pointer events so review is read-only ── */
.reviewModuleMainDiv .ant-radio-wrapper {
  cursor: default;
}
.reviewModuleMainDiv .ant-checkbox-wrapper {
  cursor: default;
  pointer-events: none;
}

/* ── Full-width layout ── */
.reviewModuleMainDiv .ant-space {
  width: 100%;
}
.reviewModuleMainDiv .ant-radio-group,
.reviewModuleMainDiv .ant-checkbox-group {
  width: 100%;
}

/* ── Red row highlight (radio + checkbox incorrect) ── */
.reviewModuleMainDiv .radio-incorrect {
  width: 100%;
  background: #ff7c7c;
  padding: 10px;
  border-radius: 10px;
}

/* ── Green row highlight (radio + checkbox correct) ── */
.reviewModuleMainDiv .radio-green {
  width: 100%;
  background: #5bc740;
  padding: 10px;
  border-radius: 10px;
}

/* ── Default radio row ── */
.reviewModuleMainDiv .ant-radio-wrapper {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
}

/* ── Default checkbox row ── */
.reviewModuleMainDiv .ant-checkbox-wrapper {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
}

/* ── Checkbox: correct option (green) ── */
.reviewModuleMainDiv .radio-green.ant-checkbox-wrapper
  .ant-checkbox-inner {
  border-color: green !important;
  background-color: green !important;
}
.reviewModuleMainDiv .radio-green.ant-checkbox-wrapper
  .ant-checkbox-checked
  .ant-checkbox-inner {
  border-color: green !important;
  background-color: green !important;
}
.reviewModuleMainDiv .radio-green.ant-checkbox-wrapper
  .ant-checkbox-inner::after {
  border-color: #fff !important;
}

/* ── Checkbox: user's wrong pick (red) ── */
.reviewModuleMainDiv .radio-incorrect.ant-checkbox-wrapper
  .ant-checkbox-inner {
  border-color: red !important;
  background-color: red !important;
}
.reviewModuleMainDiv .radio-incorrect.ant-checkbox-wrapper
  .ant-checkbox-checked
  .ant-checkbox-inner {
  border-color: red !important;
  background-color: red !important;
}
.reviewModuleMainDiv .radio-incorrect.ant-checkbox-wrapper
  .ant-checkbox-inner::after {
  border-color: #fff !important;
}

/* ── Result type badges ── */
.correctAnswerResultType {
  float: right;
  border: 1px solid #5bc740;
  border-radius: 25px;
  padding: 5px 7px;
  width: 150px;
  text-align: center;
  color: #5bc740;
  cursor: default;
}
.wrongAnswerResultType {
  float: right;
  border: 1px solid #ff7c7c;
  border-radius: 25px;
  padding: 5px 7px;
  width: 150px;
  text-align: center;
  color: #ff7c7c;
  cursor: default;
}

/* ── Text answer block (fb / fbd) ── */
.textAnswers {
  padding: 12px 0 4px;
}
.textAnswers p {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.6;
}

/* ── Page title ── */
.reviewAnswerClass {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
  margin-bottom: 16px;
}

/* ── Dashboard button ── */
.DashboardButton {
  margin-bottom: 20px;
  position: relative;
  left: 45%;
}

/* ── Hover: don't change border color for read-only radios ── */
.reviewModuleMainDiv .ant-radio-wrapper:hover .ant-radio-inner {
  border-color: #c1c1c1;
}

/* ── Top margin ── */
.reviewModuleMainDiv {
  margin-top: 70px;
  max-width: 860px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 16px 60px;
}

/* ── Gradient button ── */
.Button {
  height: 56px !important;
  padding: 0 48px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  border-radius: 16px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4) !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}
.Button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5) !important;
}
.Button:active {
  transform: translateY(0);
}

/* ── Timer / redirect banner ── */
.timerBox {
  height: 56px;
  padding: 0 48px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: white;
  margin-bottom: 20px;
}
.timerBox:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5);
}
.timerBox:active {
  transform: translateY(0);
}

/* ── Dashboard centre wrapper ── */
.dashboardCenter {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .reviewModuleMainDiv {
    padding: 0 8px 40px;
  }
  .timerBox {
    height: auto;
    padding: 12px 16px;
    font-size: 14px;
  }
  .correctAnswerResultType,
  .wrongAnswerResultType {
    float: none;
    display: block;
    margin-bottom: 10px;
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Courses/Assessment/ManualAssessment/ScoreAndReviewPage/ManualReview.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;;EAEE,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;;;EAGE,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;;EAEE,6BAA6B;AAC/B;;AAEA,4CAA4C;AAC5C;;EAEE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;;;EAGE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;;EAEE,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA,gEAAgE;AAChE;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,wEAAwE;EACxE,uBAAuB;EACvB,0DAA0D;EAC1D,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,0DAA0D;AAC5D;AACA;EACE,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;AACA;EACE,wBAAwB;AAC1B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;EACA;;IAEE,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,WAAW;EACb;AACF","sourcesContent":[".correctAnswerCard {\n  background-color: #eafff0;\n  border-color: #a2ffbb;\n  margin-bottom: 16px;\n}\n.wrongAnswerCard {\n  background-color: #ffeaea;\n  border-color: #ffa2a2;\n  margin-bottom: 16px;\n}\n\n/* ── Radio: incorrect (red) ── */\n.radio-red .ant-radio-inner {\n  border-color: red;\n}\n.radio-red .ant-radio-inner::after {\n  background-color: red;\n}\n\n/* ── Radio: correct (green) ── */\n.radio-green .ant-radio-inner {\n  border-color: green !important;\n  background: green;\n}\n.radio-green .ant-radio-inner::after {\n  background-color: green !important;\n}\n.radio-green .ant-radio-checked .ant-radio-inner {\n  border-color: green;\n  background-color: green;\n}\n\n/* ── Radio: user's wrong pick ── */\n.radio-incorrect .ant-radio-checked .ant-radio-inner {\n  border-color: red;\n  background-color: red;\n}\n\n/* ── Hover states ── */\n.reviewModuleMainDiv .radio-green:hover .ant-radio-inner {\n  border-color: green;\n}\n.reviewModuleMainDiv .radio-incorrect:hover .ant-radio-inner {\n  border-color: red !important;\n}\n\n.radio-correct {\n  color: green;\n}\n\n/* ── Disable pointer events so review is read-only ── */\n.reviewModuleMainDiv .ant-radio-wrapper {\n  cursor: default;\n}\n.reviewModuleMainDiv .ant-checkbox-wrapper {\n  cursor: default;\n  pointer-events: none;\n}\n\n/* ── Full-width layout ── */\n.reviewModuleMainDiv .ant-space {\n  width: 100%;\n}\n.reviewModuleMainDiv .ant-radio-group,\n.reviewModuleMainDiv .ant-checkbox-group {\n  width: 100%;\n}\n\n/* ── Red row highlight (radio + checkbox incorrect) ── */\n.reviewModuleMainDiv .radio-incorrect {\n  width: 100%;\n  background: #ff7c7c;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n/* ── Green row highlight (radio + checkbox correct) ── */\n.reviewModuleMainDiv .radio-green {\n  width: 100%;\n  background: #5bc740;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n/* ── Default radio row ── */\n.reviewModuleMainDiv .ant-radio-wrapper {\n  width: 100%;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n/* ── Default checkbox row ── */\n.reviewModuleMainDiv .ant-checkbox-wrapper {\n  width: 100%;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n/* ── Checkbox: correct option (green) ── */\n.reviewModuleMainDiv .radio-green.ant-checkbox-wrapper\n  .ant-checkbox-inner {\n  border-color: green !important;\n  background-color: green !important;\n}\n.reviewModuleMainDiv .radio-green.ant-checkbox-wrapper\n  .ant-checkbox-checked\n  .ant-checkbox-inner {\n  border-color: green !important;\n  background-color: green !important;\n}\n.reviewModuleMainDiv .radio-green.ant-checkbox-wrapper\n  .ant-checkbox-inner::after {\n  border-color: #fff !important;\n}\n\n/* ── Checkbox: user's wrong pick (red) ── */\n.reviewModuleMainDiv .radio-incorrect.ant-checkbox-wrapper\n  .ant-checkbox-inner {\n  border-color: red !important;\n  background-color: red !important;\n}\n.reviewModuleMainDiv .radio-incorrect.ant-checkbox-wrapper\n  .ant-checkbox-checked\n  .ant-checkbox-inner {\n  border-color: red !important;\n  background-color: red !important;\n}\n.reviewModuleMainDiv .radio-incorrect.ant-checkbox-wrapper\n  .ant-checkbox-inner::after {\n  border-color: #fff !important;\n}\n\n/* ── Result type badges ── */\n.correctAnswerResultType {\n  float: right;\n  border: 1px solid #5bc740;\n  border-radius: 25px;\n  padding: 5px 7px;\n  width: 150px;\n  text-align: center;\n  color: #5bc740;\n  cursor: default;\n}\n.wrongAnswerResultType {\n  float: right;\n  border: 1px solid #ff7c7c;\n  border-radius: 25px;\n  padding: 5px 7px;\n  width: 150px;\n  text-align: center;\n  color: #ff7c7c;\n  cursor: default;\n}\n\n/* ── Text answer block (fb / fbd) ── */\n.textAnswers {\n  padding: 12px 0 4px;\n}\n.textAnswers p {\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* ── Page title ── */\n.reviewAnswerClass {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1a1a2e;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n/* ── Dashboard button ── */\n.DashboardButton {\n  margin-bottom: 20px;\n  position: relative;\n  left: 45%;\n}\n\n/* ── Hover: don't change border color for read-only radios ── */\n.reviewModuleMainDiv .ant-radio-wrapper:hover .ant-radio-inner {\n  border-color: #c1c1c1;\n}\n\n/* ── Top margin ── */\n.reviewModuleMainDiv {\n  margin-top: 70px;\n  max-width: 860px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 16px 60px;\n}\n\n/* ── Gradient button ── */\n.Button {\n  height: 56px !important;\n  padding: 0 48px !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  border-radius: 16px !important;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n  border: none !important;\n  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4) !important;\n  transition: all 0.3s ease !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n}\n.Button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5) !important;\n}\n.Button:active {\n  transform: translateY(0);\n}\n\n/* ── Timer / redirect banner ── */\n.timerBox {\n  height: 56px;\n  padding: 0 48px;\n  font-size: 18px;\n  font-weight: 600;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: white;\n  margin-bottom: 20px;\n}\n.timerBox:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5);\n}\n.timerBox:active {\n  transform: translateY(0);\n}\n\n/* ── Dashboard centre wrapper ── */\n.dashboardCenter {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  width: 100%;\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .reviewModuleMainDiv {\n    padding: 0 8px 40px;\n  }\n  .timerBox {\n    height: auto;\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n  .correctAnswerResultType,\n  .wrongAnswerResultType {\n    float: none;\n    display: block;\n    margin-bottom: 10px;\n    width: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
